import useToken from 'hooks/useToken';
import React, { useEffect, useState } from 'react';

import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import { Card, Col, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import SkeletonTable from '../../../../components/common/SkeletonTable';
import { useToast } from 'context/providers/ToastProvider';

const ListaNomina = () => {

    const { showErrorToast } = useToast();

    /**
    * Columna para mostrar datos de facturas emitidas 
    */
    const columns = [
        {
            accessor: 'vFolio',
            Header: 'Folio',
            headerProps: { className: 'align-middle text-center bg-light' },
            cellProps: { className: 'align-middle' },
            width: 100,
            Cell: rowData => (
                <span className="fw-medium  text-primary">
                    {rowData.row.original.vFolio}
                </span>
            )
        },
        {
            accessor: 'vSerie',
            Header: 'Serie',
            headerProps: { className: 'align-middle text-center bg-light' },
            cellProps: { className: 'align-middle' },
            width: 100,
            Cell: rowData => (
                <span className="fw-medium  text-black">
                    {rowData.row.original.vSerie}
                </span>
            )
        },
        {
            accessor: 'NumEmpleado',
            Header: 'Num Empl.',
            headerProps: { className: 'align-middle text-center bg-light' },
            cellProps: { className: 'align-middle' },
            width: 100,
            Cell: rowData => (
                <span className="fw-medium  text-black">
                    {rowData.row.original.NumEmpleado}
                </span>
            )
        },
        {
            accessor: 'vRfcEmisor',
            Header: 'RFC Emisor',
            headerProps: { className: 'align-middle text-center bg-light' },
            cellProps: { className: 'align-middle ' },
            width: 150,
            Cell: rowData => (
                <div className="fw-medium text-primary">
                    {rowData.row.original.vRfcEmisor}
                </div>
            )
        },
        {
            accessor: 'vRazonSocialEmisor',
            Header: 'Razón Social Emisor',
            headerProps: { className: 'align-middle bg-light' },
            cellProps: {
                className: 'ps-3 align-middle text-truncate',
                style: { maxWidth: '180px' }
            },
            width: 200,
            Cell: rowData => (
                <span title={rowData.row.original.vRazonSocialEmisor} className="text-dark fw-medium d-inline-block text-truncate" style={{ fontSize: '0.9em', maxWidth: '100%' }}>
                    {rowData.row.original.vRazonSocialEmisor}
                </span>
            )
        },
        {
            accessor: 'vRfcReceptor',
            Header: 'RFC Receptor',
            headerProps: { className: 'align-middle text-center bg-light' },
            cellProps: { className: 'align-middle ' },
            width: 150,
            Cell: rowData => (
                <div className="fw-medium text-primary">
                    {rowData.row.original.vRfcReceptor}
                </div>
            )
        },
        {
            accessor: 'vRazonSocialReceptor',
            Header: 'Razon Social Receptor',
            headerProps: { className: 'align-middle bg-light' },
            cellProps: {
                className: 'ps-3 align-middle text-truncate',
                style: { maxWidth: '180px' }
            },
            width: 200,
            Cell: rowData => (
                <span title={rowData.row.original.vRazonSocialReceptor} className="text-dark fw-medium d-inline-block text-truncate" style={{ fontSize: '0.9em', maxWidth: '100%' }}>
                    {rowData.row.original.vRazonSocialReceptor}
                </span>
            )
        },
        
        {
            accessor: 'FechaPago',
            Header: 'Fecha Pago',
            Cell: rowData => {
                const rawFecha = rowData.row.original?.FechaPago;

                if (!rawFecha) return <span>Sin fecha</span>;

                return <span>
                            {new Date(rawFecha).toLocaleDateString('es-mx', { year: 'numeric', month: 'short', day: 'numeric' })}
                       </span>;
            }
        },
        {
            accessor: 'TipoNomina',
            Header: 'Tipo Nom.',
            headerProps: { className: 'align-middle text-center bg-light' },
            cellProps: {
                className: 'ps-3 align-middle text-truncate',
                style: { maxWidth: '180px' } // Reducido de 250px
            },
            width: 200, // Añadir ancho de columna
            Cell: rowData => (

                <span
                    className="text-dark fw-medium d-inline-block text-truncate"
                    style={{ fontSize: '0.9em', maxWidth: '100%' }}
                >
                    {rowData.row.original.TipoNomina}
                </span>
            )
        },
        {
            accessor: 'TotalPercepciones',
            Header: 'Total Percep.',
            headerProps: { className: 'align-middle text-end bg-light' },
            cellProps: { className: 'align-middle text-end' },
            width: 140,
            Cell: rowData => (
                <div className="text-dark">
                    {parseFloat(rowData.row.original.TotalPercepciones).toLocaleString('es-MX', {
                        style: 'currency',
                        currency: 'MXN'
                    })}
                </div>
            )
        },
        {
            accessor: 'TotalDeducciones',
            Header: 'Total Deduc.',
            headerProps: { className: 'align-middle text-end bg-light' },
            cellProps: { className: 'align-middle text-center' },
            width: 140,
            Cell: rowData => (
                <div className="text-dark">
                    {parseFloat(rowData.row.original.TotalDeducciones).toLocaleString('es-MX', {
                        style: 'currency',
                        currency: 'MXN'
                    })}
                </div>
            )
        },
        {
            accessor: 'dTotal',
            Header: 'Total',
            headerProps: { className: 'align-middle text-end bg-light' },
            cellProps: { className: 'align-middle text-end' },
            width: 120,
            Cell: rowData => (
                <div className="fw-bold text-dark">
                    {parseFloat(rowData.row.original.dTotal).toLocaleString('es-MX', {
                        style: 'currency',
                        currency: 'MXN'
                    })}
                </div>
            )
        },
        {
            accessor: 'Departamento',
            Header: 'Departamento',
            headerProps: { className: 'align-middle text-center bg-light' },
            cellProps: { className: 'ps-3 align-middle text-truncate', style: { maxWidth: '140px' } },
            width: 200,
            Cell: rowData => (
                <span
                    className="text-dark fw-medium d-inline-block text-truncate"
                    style={{ fontSize: '0.9em', maxWidth: '100%' }}
                >
                    {rowData.row.original.Departamento}
                </span>
            )
        },
        {
            accessor: 'Puesto',
            Header: 'Puesto',
            headerProps: { className: 'align-middle text-center bg-light' },
            cellProps: { className: 'ps-3 align-middle text-truncate', style: { maxWidth: '140px' } },
            width: 200,
            Cell: rowData => (
                <span
                    className="text-dark fw-medium d-inline-block text-truncate"
                    style={{ fontSize: '0.9em', maxWidth: '100%' }}
                >
                    {rowData.row.original.Puesto}
                </span>
            )
        }
    ];

    const { token, setToken } = useToken();
    const [nominas, setNominas] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [rfc, setRFC] = useState([]);
    const [selectedRfc, setSelectedRfc] = useState("");
    const [dateQuarter, setDateQuarter] = useState(new Date());

    /**
    * Se ejecuta la primera vez
    */
    useEffect(() => {
        obtenerListaNomina();
    }, [selectedRfc]);

    /**
    * Se ejecuta la primera vez
    */
    useEffect(() => {
        obtenerRfcReceptor();
    }, []);


    /**
     * Funcion para obtener los rfc para el filtro
     */
    const obtenerRfcReceptor = async () => {

        const response = await fetch("/api/FacturasEmitidas/ObtenerRFCReceptor",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const data = await response.json();

            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);

                setRFC(ObjDetalles.table2);

                setSelectedRfc(ObjDetalles.table2[0].vRFC);

            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
    * Funcion para mostrar datos de la lista nominas
    */
    const obtenerListaNomina = async () => {
        setCargando(true);

        var date_ = sessionStorage.getItem("selectMes") == null ? dateQuarter : sessionStorage.getItem("selectMes");

        setDateQuarter(new Date(date_));

        var month = new Date(date_).getMonth();
        month = month + 1;
        var year = new Date(date_).getFullYear();

        const data = {
            year: year,
            month: month,
            rfc: selectedRfc
        }
        console.log("fecha enviada", data)

        const response = await fetch("/api/Contabilidad/ObtenerListaNominas",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            console.log("==== informacion ====");
            console.log("response: ", response);
            const data = await response.json();
            console.log("data: ", data);

            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);

                console.log("ObjDetalles:", ObjDetalles);

                setNominas(ObjDetalles.table2);

            } else {
                showErrorToast(data.vMessage);
            }
            setCargando(false);

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
     * Función para manejar el cambio de fecha
     */
    const handleDateChange = (date) => {
        setDateQuarter(date);
        sessionStorage.setItem("selectMes", date);
        obtenerListaNomina();
    };


    return (
        <>
            <AdvanceTableWrapper
                columns={columns}
                data={nominas}

                sortable
                pagination
                perPage={15}
            >
                <Card className="mb-3">
                    <Card.Header className="pb-0">
                        <Row className="justify-content-between align-items-end mb-3">
                            {/* Contenedor principal de los filtros */}
                            <Col xs={12} md={9}>
                                <Row className="g-3 align-items-end"> {/* g-3 para espaciado entre columnas */}
                                    {/* Grupo DatePicker */}
                                    <Col xs={12} sm={4} md={3}>
                                        <div className="text-start">
                                            <Form.Label className="text-700 mb-2 d-block">Mes</Form.Label>
                                        </div>
                                        <DatePicker
                                            selected={dateQuarter}
                                            onChange={handleDateChange}
                                            dateFormat="MMMM yyyy - QQQ"
                                            className="form-control w-100"
                                            showMonthYearPicker
                                        />
                                    </Col>

                                    {/* Grupo RFC Emisor */}
                                    <Col xs={12} sm={4} md={3}>
                                        <div className="text-start">
                                            <Form.Label className="text-700 mb-2 d-block">RFC Emisor</Form.Label>
                                        </div>
                                        <Form.Select
                                            size="xs"
                                            value={selectedRfc}
                                            onChange={(e) => setSelectedRfc(e.target.value)}
                                            className="w-100"
                                        >
                                            {rfc.map((item, index) => (
                                                <option key={index} value={item.vRFC}>
                                                    {item.vRFC}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                </Row>
                            </Col>

                            {/* Barra de búsqueda (derecha) */}
                            <Col xs={12} md={3} className="mt-3 mt-md-0">
                                <AdvanceTableSearchBox
                                    style={{ maxWidth: '200px' }}
                                    table
                                />
                            </Col>
                        </Row>
                    </Card.Header>
                    <Card.Body className="p-0">
                        {
                            cargando ? (
                                <SkeletonTable columnNames={['Folio', 'Serie', 'Num...', 'RFC E...', 'Razon S. Emi...', 'RFC Receptor', 'Razon Soc. Rec', 'Fecha Pago', 'Tipo Nom', 'Total Percep', 'Total Deduc.', 'Total', 'Departamento']} rows={11} />
                            ) : (
                                <AdvanceTable
                                    table
                                    headerClassName="bg-200 text-900 text-nowrap align-middle"
                                    rowClassName="align-middle white-space-nowrap"
                                    tableProps={{
                                        size: 'sm',
                                        striped: true,
                                        className: 'fs--2 mb-0 overflow-hidden'
                                    }}
                                />
                            )
                        }   
                    </Card.Body>
                    <Card.Footer>
                        <AdvanceTableFooter
                            rowCount={nominas.length}
                            table
                            rowInfo
                            navButtons
                            rowsPerPageSelection
                        />
                    </Card.Footer>
                </Card>
            </AdvanceTableWrapper>
        </>
    );
};

export default ListaNomina;
